module.exports = __webpack_public_path__ + "img/scale_small.8fef5b4a.svg";